/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProgramWorkBreakdown_viewer = {
    readonly id: string;
    readonly program: {
        readonly id: string;
        readonly projectTaskStatusBreakdown: {
            readonly todoPercentage: number | null;
            readonly inProgressPercentage: number | null;
            readonly donePercentage: number | null;
        } | null;
    } | null;
    readonly " $refType": "ProgramWorkBreakdown_viewer";
};
export type ProgramWorkBreakdown_viewer$data = ProgramWorkBreakdown_viewer;
export type ProgramWorkBreakdown_viewer$key = {
    readonly " $data"?: ProgramWorkBreakdown_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProgramWorkBreakdown_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "prefix",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgramWorkBreakdown_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "prefix",
          "variableName": "prefix"
        }
      ],
      "concreteType": "ProgramType",
      "kind": "LinkedField",
      "name": "program",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectTaskStatusBreakdown",
          "kind": "LinkedField",
          "name": "projectTaskStatusBreakdown",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "todoPercentage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "inProgressPercentage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "donePercentage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'e290b2ab4ab39dc12b572e24659bf8cd';
export default node;
